import TrainingCourseListPage from '../TrainingCourses/ListPage';
import {useTranslation} from 'react-i18next';
import usePageMeta from '../../services/page-meta';

export default function TestingsListPage() {
    const {t} = useTranslation();
    usePageMeta({
        title: t('testings.title', 'Testings'),
        description: t('app.description'),
        keywords: t('app.keywords'),
    });

    return <TrainingCourseListPage isTesting={true} tab="all" />;
}
